export default __webpack_public_path__ + "static/media/img4.03706b60.png";